var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.268.285H7.895A7.895 7.895 0 0 0 0 8.18v27.07a7.895 7.895 0 0 0 7.895 7.896h47.373a7.895 7.895 0 0 0 7.895-7.895V8.18A7.895 7.895 0 0 0 55.268.285z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.696 28.53H25.19l2.193-13.586h3.506L28.696 28.53zm12.709-13.254a8.624 8.624 0 0 0-3.144-.58c-3.463 0-5.9 1.85-5.915 4.496-.03 1.952 1.745 3.036 3.072 3.687 1.357.665 1.818 1.099 1.818 1.69-.014.91-1.096 1.33-2.106 1.33-1.4 0-2.15-.215-3.29-.722l-.46-.217-.491 3.05c.822.376 2.337.709 3.91.723 3.678 0 6.073-1.821 6.101-4.64.014-1.546-.922-2.732-2.942-3.7-1.227-.622-1.977-1.041-1.977-1.677.014-.58.635-1.17 2.019-1.17a5.944 5.944 0 0 1 2.611.52l.317.144.477-2.934zm4.66 8.442c.289-.78 1.4-3.802 1.4-3.802-.015.03.288-.795.46-1.3l.246 1.17s.664 3.252.808 3.932h-2.914zm4.327-8.774h-2.711c-.837 0-1.472.245-1.833 1.127l-5.207 12.46h3.678l.736-2.038h4.501c.101.477.419 2.038.419 2.038h3.246l-2.829-13.587zm-28.13 0-3.433 9.265-.376-1.88c-.634-2.167-2.625-4.523-4.847-5.694l3.145 11.882h3.708l5.51-13.573h-3.707z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.64 14.944H10l-.058.274c4.4 1.128 7.314 3.846 8.511 7.113l-1.226-6.245c-.202-.868-.822-1.113-1.587-1.142z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.268 1.285H7.895A6.895 6.895 0 0 0 1 8.18v27.07a6.895 6.895 0 0 0 6.895 6.896h47.373a6.895 6.895 0 0 0 6.895-6.895V8.18a6.895 6.895 0 0 0-6.895-6.895z",
    stroke: "url(#c)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(95.783 15.09 28.055) scale(26.3581 39.2325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ECC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#EDB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E99999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E66F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E74141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81515"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v44H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -50,
    y: -50,
    width: 164,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_428_308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_428_308",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6026b9cfe37792fb23055bbbb9f170ed.svg";
export { ForwardRef as ReactComponent };